module.exports = __webpack_public_path__ + "static/media/cadastro.13f1cec2.svg";